<template>
  <div class="hello">
      <sui-button floated="right" content="Refresh" icon="refresh" v-on:click="refresh()" />
      <router-link :to="{'name': 'device_activate'}"><sui-button floated="right" content="Activate new device" icon="plus" primary /></router-link>
    <h1>Device list</h1>
    <sui-grid>
    <sui-grid-row>
      <sui-grid-column align="right">
        <sui-checkbox label="Show deactivated devices" toggle v-model="displayDeactivated" v-on:click="updateDisplayDeactivated($event)" />
      </sui-grid-column>
    </sui-grid-row>
    <sui-grid-row>
      <sui-grid-column>
        <sui-table single-line v-if="allDevices.length>0">
          <sui-table-header>
            <sui-table-row>
              <sui-table-header-cell>Id</sui-table-header-cell>
              <sui-table-header-cell>Type</sui-table-header-cell>
              <sui-table-header-cell v-if="displayDeactivated">Active</sui-table-header-cell>
              <sui-table-header-cell>Channel</sui-table-header-cell>
              <sui-table-header-cell>Last data</sui-table-header-cell>
              <sui-table-header-cell>Detail</sui-table-header-cell>
            </sui-table-row>
          </sui-table-header>
          <sui-table-body>
            <sui-table-row v-for="(device, deviceIndex) in allDevices" v-bind:key="deviceIndex">
                <sui-table-cell>{{ device.deviceId }}</sui-table-cell>
                <sui-table-cell v-if="device.status=='active'">{{ device.type }}</sui-table-cell>
                <sui-table-cell v-else>{{ device.deviceAttributes.type }} (inactive)</sui-table-cell>
                <sui-table-cell v-if="displayDeactivated">
                    <span v-if="device.status=='active'">Active</span>
                    <span v-else>{{ device.timestamp | moment('D. M. Y') }} - {{ device.timestampEnd | moment('D. M. Y') }}</span>
                </sui-table-cell>
                <sui-table-cell v-if="device.status=='active'"><AliasInlineEditor :alias="device.alias" :deviceId="device.deviceId" /></sui-table-cell>
                <sui-table-cell v-else><router-link :to="'/channel/' + device.deviceAttributes.alias" class="nav-link">{{ device.deviceAttributes.alias }}</router-link></sui-table-cell>
                <sui-table-cell v-if="device.status=='active'">{{ device.lastHistory | moment("from") }}</sui-table-cell>
                <sui-table-cell v-else>{{ device.deviceAttributes.lastHistory | moment("from") }}</sui-table-cell>
                
                <sui-table-cell>
                    <router-link v-if="device.status=='active'" :to="'/device/' + device.deviceId" class="nav-link" icon="detail"><sui-button content="Detail" icon="eye" positive  size="mini" /></router-link>
                    <router-link v-if="device.status=='inactive'" :to="'/device/' + device.deviceId + '/' + device.timestamp" class="nav-link" icon="detail"><sui-button content="Detail" icon="eye" size="mini" /></router-link>
                </sui-table-cell>
            </sui-table-row>
          </sui-table-body>
        </sui-table>
        <div v-else>
          <sui-message icon="inbox">
            <sui-message-content>
              <sui-message-header>Activate your first device ...</sui-message-header>
              You can activate new device by clicking on  <router-link :to="{'name': 'device_activate'}"><sui-button content="Activate new device" icon="plus" size="mini" primary /></router-link>.<br />
            </sui-message-content>
          </sui-message>
          </div>
      </sui-grid-column>
    </sui-grid-row>
    <sui-grid-row v-if="eshop">
        <sui-grid-column>
            <sui-segment>
            <h2 v-if="allDevices.length<1">... or order new device</h2>
            <h2 v-else>Order new device</h2>
  
            <sui-card-group :items-per-row="4">
              <sui-card>
                <sui-image src="/static/images/wireframes/image.png" />
                <sui-card-content>
                  <sui-card-header>Barcode reader</sui-card-header>
                  <sui-card-meta>Raspberry</sui-card-meta>
                  <sui-card-description>
                    A barcode reader is an optical scanner that can read printed barcodes and decode the data contained in the barcode.
                  </sui-card-description>
                </sui-card-content>
                <sui-button attached="bottom">
                  <sui-icon name="cart" /> Add to cart
                </sui-button>
              </sui-card>
              <sui-card>
                <sui-image src="/static/images/wireframes/image.png" />
                <sui-card-content>
                  <sui-card-header>Scale</sui-card-header>
                  <sui-card-meta>Raspberry, Arduino</sui-card-meta>
                  <sui-card-description>
                    A weighing scale is a device to measure weight or mass.
                  </sui-card-description>
                </sui-card-content>
                <sui-button attached="bottom">
                  <sui-icon name="cart" /> Add to cart
                </sui-button>
              </sui-card>
              <sui-card>
                <sui-image src="/static/images/wireframes/image.png" />
                <sui-card-content>
                  <sui-card-header>Temperature</sui-card-header>
                  <sui-card-meta>Raspberry, Arduino</sui-card-meta>
                  <sui-card-description>
                    A thermometer is a device that measures temperature or a temperature gradient.
                  </sui-card-description>
                </sui-card-content>
                <sui-button attached="bottom">
                  <sui-icon name="cart" /> Add to cart
                </sui-button>
              </sui-card>
              <sui-card>
                <sui-image src="/static/images/wireframes/image.png" />
                <sui-card-content>
                  <sui-card-header>RFID</sui-card-header>
                  <sui-card-meta>Raspberry, Arduino</sui-card-meta>
                  <sui-card-description>
                    Radio-frequency identification (RFID) uses electromagnetic fields to automatically identify and track tags attached to objects.
                  </sui-card-description>
                </sui-card-content>
                <sui-button attached="bottom">
                  <sui-icon name="cart" /> Add to cart
                </sui-button>
              </sui-card>
            </sui-card-group>
          </sui-segment>
        </sui-grid-column>
    </sui-grid-row>
  </sui-grid>
    
    
  
  </div>
  
  
  
</template>

<script>
import DziService from '@/DziService'
import AliasInlineEditor from '@/components/Device/AliasInlineEditor.vue';
//import { mapState } from 'vuex'

export default {
  name: 'DeviceList',
  data () {
        return {
            activation: false,
            displayDeactivated: false,
        }
    },  

  computed: {
    eshop: function() {
       return this.$store.state.eshop 
    },
    allDevices: function() {
        var output = [];
        for(let i in this.$store.getters.getDevices)
        {
            let device = this.$store.state.devices[i];
            device.status = 'active';
            output.push(device);
        }
        if (this.displayDeactivated)
        {
          for(let i in this.$store.state.deactivatedDevices)
          {
              let device = this.$store.state.deactivatedDevices[i];
              device.status = 'inactive';
              output.push(device);
          }
        }
        return output;
    }
  },
    methods: {
        refresh() {
            this.getDevices();
            if (this.$store.state.displayDeactivated)
            {
                this.getDeactivatedDevices();
            }  
        },
        updateDisplayDeactivated()
        {
            this.$store.commit('setDisplayDeactivated', this.displayDeactivated);
            
            if (this.displayDeactivated)
            {
                this.refresh();
            }
        },
        async getDevices () {
            const response = await DziService.getDevices()
            this.$store.commit('setDevices', response.data);
            
        },
        async getDeactivatedDevices () {
            const response = await DziService.getDeactivatedDevices()
            this.$store.commit('setDeactivatedDevices', response.data);
            
        }
    },
    mounted () {
        this.displayDeactivated = this.$store.state.displayDeactivated;
        if (!this.$store.getters.getDevices || this.$store.getters.getDevices.length<1)
            this.refresh();
        
        },
        components: {
            AliasInlineEditor: AliasInlineEditor
        }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
